import LockTableMouseEventsHandlerState from "./LockTableMouseEventsHandlerState";
import {getEventObj} from "../atBrowserUtils"

export default class LockTableHoverState extends LockTableMouseEventsHandlerState {
    constructor(mouseEventsHandler) {
        super(mouseEventsHandler);
    }

    mouseOver(evt, cell) {
        //ignore hover for row header
        if (cell.getColIdx() == 0)
            return;

        //ignore hover if cell already hovered
        if (this.mouseEventsHandler.hoverController.isHovered(cell))
            return;

        let mouseEventsHandler = this.mouseEventsHandler;
        cell.getRow().accept(
            {
                visitUserRow(cell) {
                    let endCell = cell;
                    if (cell.getRow().getChildRows().length > 0) {
                        endCell = cell.getRow().getLastChildRow().getCell(cell.getColIdx());
                    }
                    mouseEventsHandler.hoverController.hover(cell, endCell);
                },

                visitDetailsRow(cell) {
                    this.visitUserRow(cell.getRow().getParentRow().getCell(cell.getColIdx()));
                },

                visitDatesRow(cell) {
                    mouseEventsHandler.hoverController.hover(cell, cell);
                },

                visitRunnerRow(cell) {
                    mouseEventsHandler.getRunnerController().hover(cell);
                },

                visitInactiveRow(cell) {
                    //do nothing for inactive row
                }
            },
            cell
        );
    }

    mouseOut(evt, cell) {
        evt = getEventObj(evt);
        if (this.shouldRemoveHover(cell, getTargetElement(evt))) {
            let mouseEventsHandler = this.mouseEventsHandler;
            cell.getRow().accept(
                {
                    visitUserRow(cell) { mouseEventsHandler.hoverController.unhover(); },
                    visitDetailsRow(cell) { mouseEventsHandler.hoverController.unhover(); },
                    visitDatesRow(cell) { mouseEventsHandler.hoverController.unhover(); },
                    visitRunnerRow(cell) {
                        mouseEventsHandler.getRunnerController().unhover(cell);
                    },
                    visitInactiveRow(cell) { }
                },
                cell
            );
        }
    }

    shouldRemoveHover(cell, targetElement) {
        let targetCell = null;
        while (targetElement) {
            if (targetElement.cellObj) {
                targetCell = targetElement.cellObj;
                break;
            }
            targetElement = targetElement.parentNode;
        }

        if (targetCell == null)
            return true;

        return !this.hasEqualHover(cell, targetCell);
    }

    hasEqualHover(cell1, cell2) {
        if (cell1 == cell2)
            return true;

        //only details and user cells in the same column can have equal hovers
        if (cell1.getColIdx() != cell2.getColIdx())
            return false;

        let userCellGetter = {
            visitUserRow(cell) { return cell },
            visitDetailsRow(cell) { return cell.getRow().getParentRow().getCell(cell.getColIdx()) },
            visitDatesRow(cell) { return null },
            visitRunnerRow(cell) { return null },
            visitInactiveRow(cell) { return null }
        };

        let userDayCell1 = cell1.getRow().accept(userCellGetter, cell1);
        let userDayCell2 = cell2.getRow().accept(userCellGetter, cell2);

        return userDayCell1 != null && userDayCell1 == userDayCell2;
    }

    mouseDown(evt, cell) {
        //ignore selection start for row headers
        if (cell.getColIdx() == 0)
            return;

        let mouseEventsHandler = this.mouseEventsHandler;
        cell.getRow().accept(
            {
                visitUserRow(cell) {
                    mouseEventsHandler.hoverController.unhover();
                    mouseEventsHandler.setCellSelectionState(cell);
                },

                visitDetailsRow(cell) {
                    mouseEventsHandler.hoverController.unhover();
                    mouseEventsHandler.setCellSelectionState(
                        cell.getRow().getParentRow().getCell(cell.getColIdx())
                    );
                },

                visitDatesRow(cell) {
                    mouseEventsHandler.hoverController.unhover();
                    mouseEventsHandler.setColumnSelectionState(cell);
                },

                visitRunnerRow(cell) { },

                visitInactiveRow(cell) { }
            },
            cell
        );
    }

    mouseUp(evt, cell) {
        if (cell == null)
            return;

        if (cell.getColIdx() == 0)
            return;

        let mouseEventsHandler = this.mouseEventsHandler;

        cell.getRow().accept(
            {
                visitUserRow(cell) { },
                visitDetailsRow(cell) { },
                visitDatesRow(cell) { },
                visitRunnerRow(cell) {
                    mouseEventsHandler.getSelectionController().clearSelection();
                    mouseEventsHandler.getRunnerController().setNewLastLockedCell(cell);
                    if (mouseEventsHandler.getSelectionController().hasSelection()) {
                        mouseEventsHandler.setRangeSelectedState();
                        mouseEventsHandler.fireSelectionFinished(evt);
                    }
                },
                visitInactiveRow(cell) { }
            },
            cell
        );
    }
}


// WEBPACK FOOTER //
// ./web/js/locktable/LockTableHoverState.js